import React from "react";
import {
  FeeRunParticipantContainer,
  ManageRunFeeContainer,
} from "../../../containers";

const ManageFeeRun = (props) => {
  return <ManageRunFeeContainer {...props} />;
  //return <FeeRunParticipantContainer {...props} />;
};

export default ManageFeeRun;
